import { render, staticRenderFns } from "./receipt-detail.vue?vue&type=template&id=3bdaf1f2"
import script from "./receipt-detail.vue?vue&type=script&lang=js"
export * from "./receipt-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports